import { useDispatch } from 'react-redux'
// css
import './css/swipe.css'
//images
import SwipeImg from '../images/static/gallerie/swipe.png'
//Actions
import { removeSwipe } from '../reducers/ActionsCreator'

const Swipe = () => {
	const dispatch = useDispatch()
	return(
		<div onClick={() => dispatch(removeSwipe())} className="swipe_main_container">
			<div className="swipe_img_container">
				<img src={SwipeImg} alt="" />
			</div>
			<button >
				<i className="fas fa-check"></i>
				Got it
			</button>
		</div>
		)
}

export default Swipe